import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BearCondorSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M33 21.7232H19.7923L18.6252 18.0226M1.28941 21.7232H2.98593L4.15304 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M18.6251 18.0226L14.1901 3.96046H8.58795L4.15294 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>
)

const BearCondor: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BearCondorSvg(props)}
    </SvgIcon>
));
export default BearCondor